import { render, staticRenderFns } from "./saldopiutang.vue?vue&type=template&id=684b3696&scoped=true&"
import script from "./saldopiutang.vue?vue&type=script&lang=js&"
export * from "./saldopiutang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684b3696",
  null
  
)

export default component.exports